module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2e"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "chnum"
  }, [_vm._v("chapter one")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_vm._v("BREAKING DOWN BEER STYLES")])]), _c('div', {
    staticClass: "wrapr"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "intro"
  }, [_vm._v("In the past, beer books and other so-called official sources have traditionally organized beer styles by country or region. I’ve taken a different approach and created a guide that relates to the way most people actually drink. For example, if you already know you like hoppy beers, you can jump straight to the IPA or Other Hoppy Beers chapters. If you love malty and dark beers, it’s clear which chapters are for you as well. I hope that means you can easily flip through and figure out exactly where you want to start reading (and sampling, of course!).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The exception to this is the Belgian beer chapter. Since those styles are so unique, and their signature flavors are largely determined by particular Belgian yeasts, they really belong together rather than mixed among the other chapters. Also, I’ve found that even though the beers have a wide range of flavors, many beer drinkers either fall in love with almost all of them or none at all.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s important to note that some beer styles might have been not-so-accidentally left out and some not-exactly-recognized-yet beer styles might have been thrown into the mix. Some styles also get a ton of attention, while others barely get a mention. What can I say? The beer world is ever expanding and our collective attention span is ever diminishing. And this is my book so I get to play favorites, right?")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("So here’s what will happen: I’ll start each section with some general notes to provide some context and some backstory behind the styles that follow, then dive into a handful of specific beers. Once you get into the beers, the entries will contain the same parts to make an apples-to-apples, or should I say beer-to-beer, comparison as easy as could be:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Style name:")]), _vm._v(" This is pretty self-explanatory.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("The gist:")]), _vm._v(" You’ll find this in italics right under the style name. It’s a 140-character or less description of the style, so it’s perfect for skimming and tweeting while reading (hint hint).")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('strong', [_vm._v("My two cents:")]), _vm._v(" This is where things get fun. How does it look, smell, and taste? Pour one for yourself and compare notes with me. Since some styles are more dynamic than others, some descriptions may be a little wackier than others. Keep in mind that this section is somewhat based on the style standards, but it is more than a bit subjective. It’s the beer style as seen through the eyes of the wench. If a particular description gets you excited, and you want a full-on download of straight style knowledge, the websites for both the Brewers Association (")]), _c('a', {
    attrs: {
      "href": "http://www.brewersassociation.org",
      "target": "_blank"
    }
  }, [_vm._v("www.brewersassociation.org")]), _vm._v(") and the Beer Judge Certification Program (BJCP, "), _c('a', {
    attrs: {
      "href": "http://www.bjcp.org",
      "target": "_blank"
    }
  }, [_vm._v("www.bjcp.org")]), _vm._v(") have links to the most up-to-date style guidelines that both organizations use for judging beer competitions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('strong', [_vm._v("Key stats:")])]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('strong', [_vm._v("Standard Reference Method (SRM):")]), _vm._v(" SRM is one of the most common ways that beer pros determine the color of a beer. I’m not going to tell you how it’s scientifically determined; it’s complicated and way above my head. However, whether you’re a brewer, beer judge, or beer drinker, you can easily reference a set of swatches to figure out where the beer in your hand falls on the scale. If you don’t have a set of swatches handy, remember the lower the SRM number, the lighter the color of the beer. The higher the number, the darker the beer. The highest number is about 40, which is typically reserved for an imperial stout. I’ve included the chart at 113.")]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('strong', [_vm._v("International Bittering Units (IBU):")]), _vm._v(" The IBU scale measures a beer’s bitterness, most of which comes from the hops, specifically the alpha acids in hops (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 111")]), _vm._v("). The scale takes into consideration two key factors: the level of alpha acids in the hop varietal and the length of extraction during the boil. It is important to note that while IBU measures the bitterness in beer, it does not necessarily measure a beer’s hoppiness. A beer may be high in hop aroma and flavor, yet low in bitterness. There is no official scale for hop aroma or flavor, only subjective observations.")]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('strong', [_vm._v("The IBU Scale:")]), _vm._v(" This technically ranges from 0 to 100, but most beer styles fall between 20 and 45 IBUs. Some styles, like lighter lagers, gruits (hopless beers), and sour beers, can fall below 20 IBUs. Other styles, such as big imperial IPAs or aggressive imperial stouts, could hit the 80–100 mark.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "hangind"
  }, [_vm._v("A few brewers and beer geeks argue that they can detect even higher levels of bitterness, but the threshold for most people is 100 IBUs. This essentially means that most people can’t tell the difference between a beer with 100 IBUs and a beer with more than 120 IBUs. The bitterness is just saturated on the palate at that point.")]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('strong', [_vm._v("Alcohol by Volume (ABV):")]), _vm._v(" ABV tells you how much alcohol is in the beer. It is determined by taking the starting (original) gravity of the beer, subtracting the final gravity, and then dividing that number by the final gravity and multiplying "), _c('em', [_vm._v("that")]), _vm._v(" number by 100. Once again, it’s not a big deal to know how to determine this number. You should just understand that the lower the ABV, the less alcohol there is in a beer, and the higher the ABV, the more alcohol there is in a beer.")])]), _c('p', {
    staticClass: "hangi"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('strong', [_vm._v("Original Gravity (OG):")]), _vm._v(" OG is a number that a lot of breweries and bars like to put on sales and marketing materials, menus, and tap lists, but few people know what it actually means. Essentially, it tells a brewer the level of fermentable sugars in the wort (sugar water made from barley, discussed on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 104")]), _vm._v("). If you are a total science nerd, you might be into calculating the OG vs. the ABV. Or eventually you may be able to see a high OG with a lower than usual ABV and figure out that the beer will taste sweeter than usual. I look at OG numbers and I’m all like, whatever. To each their own. Since it may be of interest or useful to some readers, I’m including them.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("In one word:")]), _vm._v(" If I had to sum up this beer style into one word, this is what I would say. There may be a time or two where I repeat the same word. After all, if a beer style is sexy, I’m going to call it like it is.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('strong', [_vm._v("Ales vs. Lagers")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "wrapr"
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Almost all beer styles fall under one of two parent categories: ales or lagers. The difference between these two is not color, a common misconception. It’s not region of origin or the types of malts and hops used either, though all those factors can lead to subcategories. What it really comes down to is the type of yeast.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("We will discuss the yeast at greater length starting on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 118")]), _vm._v(", but for now it’s only important to know that ales are fermented at warmer temperatures, typically for shorter periods of time, with top-fermenting yeast, the most common being "), _c('em', [_vm._v("Saccharomyces cerevisiae")]), _vm._v(". Conversely, lagers are fermented at colder temperatures over longer periods of time (typically one to two weeks longer than ales) with bottom-fermenting yeast, the most common being "), _c('em', [_vm._v("Saccharomyces pastorianus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few beer styles, namely sour beers, are spontaneously fermented with wild yeast strains and bacteria, but for the most part, all beers fall into one of these two categories.")]), _vm._v(" "), _c('p', {
    staticClass: "imagesb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/scommon1.gif",
      "width": "70%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_vm._v("Pour it into this:")]), _vm._v(" Beer is tasty in just about any clean glass, but have some fun. Pour that British bitter in a nonic pint glass and pull out your favorite tulip for that Belgian tripel. What better way is there to give yourself the full armchair-travel experience? If a particular style should be imbibed at cooler or warmer temperatures than the recommended average, I’ll also mention proper serving temperature here.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Drink instead of:")]), _vm._v(" Hey you! Put down the wine and step away from the cocktails. Grab a beer instead. For example: Instead of water, drink domestic lagers brewed with adjuncts such as corn and rice. Okay, okay. Bad joke, but you get where I’m going.")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_vm._v("Pair with:")]), _vm._v(" This will be a brief list of a few cuisines, foods, and cheeses that I recommend pairing with this style. This is just a cheat sheet. We’ll discuss beer and food pairings at greater length starting on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 155")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Brief history lesson:")]), _vm._v(" I assume your attention spans are as short as mine, so think of this section as the abridged version of beer history—the cliff notes, if you will. There are a lot of beer history books out there, many of which focus on one particular style or region, if you want to dive deeper.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Try it:")]), _vm._v(" You are drinking along with the book, right? I’ll do my best to recommend commercially produced beers in this style category, and I hope you can find at least one of them. However, bear in mind that availability of beer can be seasonal and regional, so my apologies if you strike out trying to find an Oktoberfest in April. Also, if you’re after a particular style that a nationwide brewery doesn’t make, check out your local breweries. (And if you haven’t already, check them out regardless.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("That should do it. Grab yourself a beer, and let’s begin.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0